// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const HoverCardContract = contract({
  name: "HoverCard",
  description: "Rich preview content surfaced on hover — user profile mini-cards on @-mentions, link previews, definition popups, layer-thumbnail peeks. Pointer-only by design (no touch-friendly trigger); pair with a click target for touch devices, or fall back to Popover. NEVER use HoverCard for critical info — if the user can't reach it via keyboard or touch, it might as well not exist for accessibility.",
  import: "@gradeui/ui",
  aliases: ["hover card","hover preview","mention preview","profile peek","link preview","rich tooltip","link preview card","profile hover","peek card","glass preview","frosted preview"],
  subcomponents: ["HoverCardTrigger","HoverCardContent"],
  composesWith: ["Avatar (user preview)","Card (richer content)","Link (the trigger)","MediaSurface (link/layer previews)","Code (snippet previews)"],
  styleDefaults: {"HoverCardContent":"z-50 w-64 rounded-md border p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-(--radix-hover-card-content-transform-origin)"},
  props: {
  "open": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "defaultOpen": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "onOpenChange": {
      schema: z.unknown().optional(),
      design: "event",
  },
  "openDelay": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "closeDelay": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "asChild": {
      schema: z.boolean().optional(),
      design: "plumbing",
      description: "usually a Link or Button",
  },
  "side": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "align": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "sideOffset": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "alignOffset": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "className": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "surface": {
      schema: z.enum(["solid", "translucent", "glass", "glass-strong"]).optional(),
      design: "knob",
      description: "what the preview surface is *made of*. `solid` (default) is `bg-popover`. `glass` for hover previews over rich content (a media feed, a layout canvas).",
  },
  },
});
